export const entryWrapTestId = 'cdd-entry-wrap';
export const entryLabelTestId = 'cdd-entry-label';
export const entryValueTestId = 'cdd-entry-value';
export const arrayWrapTestId = 'cdd-array-wrap';
export const arrayLabelTestId = 'cdd-array-label';
export const arrayListTestId = 'cdd-array-list';
export const arrayListItemTestId = 'cdd-array-list-item';

export const firstIndex = 0;

export const fieldTypes = {
  richText: 'RichText',
  symbol: 'Symbol',
  object: 'Object',
  array: 'Array',
  link: 'Link',
  text: 'Text',
  boolean: 'Boolean',
};

export const linkTypes = {
  entry: 'Entry',
  asset: 'Asset',
};

export const richTextFieldTypes = {
  asset: 'embedded-asset-block',
  entry: 'embedded-entry-block',
  paragraph: 'paragraph',
};

export const paragraphFieldTypes = {
  text: 'text',
  inlineEntry: 'embedded-entry-inline',
  hyperlink: 'hyperlink',
};
